import { defineMessages, useIntl } from 'react-intl';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import type { Stage } from '~/redux/api/methods/k2/getStages';

const messages = defineMessages({
  completed: {
    id: 'TasksAccordionHeader.progressCompleted',
    defaultMessage: 'Completed',
    description: 'Stage progress when all tasks are completed',
  },
  notStarted: {
    id: 'TasksAccordionHeader.progressNotStarted',
    defaultMessage: 'Not Started',
    description: 'Stage progress when no tasks are started',
  },
  completedOfTotal: {
    id: 'TasksAccordionHeader.progressCompletedOfTotal',
    defaultMessage: '{completed} of {total}',
    description: 'Stage progress showing completed count of total tasks',
  },
});

const getStageProgressLabel = (
  stageTaskSummary: Stage['task_summary'],
  formatMessage: ReturnType<typeof useIntl>['formatMessage'],
): string => {
  if (!stageTaskSummary || stageTaskSummary.total === 0) {
    return formatMessage(messages.notStarted);
  }
  if (stageTaskSummary.completed === stageTaskSummary.total) {
    return formatMessage(messages.completed);
  }

  return formatMessage(messages.completedOfTotal, {
    completed: stageTaskSummary.completed,
    total: stageTaskSummary.total,
  });
};

type Props = {
  stage: Stage;
};

export const TasksAccordionHeader = ({ stage }: Props) => {
  const intl = useIntl();

  return (
    <Layout align="center" spacing={2}>
      <Text variant="body-bold">{stage.name}</Text>
      <Text variant="tiny" color="text.secondary">
        {getStageProgressLabel(stage.task_summary, intl.formatMessage)}
      </Text>
    </Layout>
  );
};
